export enum ReactFoundationEvent {
    NAVIGATION_MENU_MOUSE_ENTER = 'foundation:navigationMenu:mouseEnter',
    SMALL_SREEN_SUGGESSTION_ON_TOUCH_MOVE = 'foundtion:smallScreen:sugession:onTouchMove',
}
